import styled from "styled-components"

export const AudiobookLabel = styled.p`
  font-size: 10px;
  color: rgb(204, 204, 204);
  overflow: hidden;
  font-family: "Interstate", "Lucida Grande", "Lucida Sans Unicode",
    "Lucida Sans", "Garuda", "Verdana", "Tahoma", sans-serif;
  font-weight: 100;
  padding: 8px 0;
  margin-bottom: 50px;
`
